import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Select from 'react-select';

// ─── Sort indicator ───────────────────────────────────────────────────────────

export function SortIcon({ col, sortConfig }) {
  if (sortConfig.col !== col) {
    return <span style={{ opacity: 0.3, marginLeft: 4 }}>⇅</span>;
  }
  return <span style={{ marginLeft: 4 }}>{sortConfig.dir === 'asc' ? '↑' : '↓'}</span>;
}

// ─── Sortable table header cell ───────────────────────────────────────────────

export function Th({ col, label, sortConfig, onSort }) {
  return (
    <th
      onClick={() => onSort(col)}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
    >
      {label}
      <SortIcon col={col} sortConfig={sortConfig} />
    </th>
  );
}

// ─── Multi-select filter dropdown ─────────────────────────────────────────────

const multiSelectStyles = {
  control: provided => ({
    ...provided,
    minHeight: 31,
    fontSize: '0.875rem',
    border: '1px solid #ced4da',
  }),
  indicatorSeparator: () => ({}),
  menu: provided => ({ ...provided, zIndex: 1050 }),
};

export function MultiFilter({ placeholder, value, options, onChange }) {
  return (
    <Select
      isMulti
      placeholder={placeholder}
      value={value || []}
      options={options}
      onChange={onChange}
      styles={multiSelectStyles}
      closeMenuOnSelect={false}
      isClearable
    />
  );
}

// ─── Controls bar (search input + filter children) ────────────────────────────

export function ControlsBar({ search, onSearch, children }) {
  return (
    <div className="d-flex flex-wrap align-items-center mt-3 mb-2" style={{ gap: '8px' }}>
      <InputGroup style={{ maxWidth: 260, flexWrap: 'nowrap' }}>
        <Form.Control
          placeholder="Search…"
          value={search}
          onChange={e => onSearch(e.target.value)}
        />
      </InputGroup>
      {children}
    </div>
  );
}

// ─── Filtered row count indicator ─────────────────────────────────────────────

export function ResultCount({ total, filtered }) {
  if (total === filtered) return null;
  return (
    <small className="text-muted" style={{ marginLeft: 'auto' }}>
      {filtered} / {total} rows
    </small>
  );
}
